/* Keep mobile overlays aligned with the visible viewport as browser chrome moves. */
(() => {
    const root = document.documentElement;
    const mobile = window.matchMedia('(max-width: 989px)');
    const viewport = window.visualViewport;
    let frame = 0;

    // Trackpad pinch is delivered as Ctrl+wheel in Chromium. Ordinary wheel
    // scrolling and browser keyboard/menu zoom remain available.
    window.addEventListener('wheel', (event) => {
        if (event.ctrlKey && event.cancelable) event.preventDefault();
    }, { passive: false });

    // Safari exposes trackpad pinch through its gesture events instead.
    function preventGestureZoom(event) {
        if (event.cancelable) event.preventDefault();
    }
    document.addEventListener('gesturestart', preventGestureZoom, { passive: false });
    document.addEventListener('gesturechange', preventGestureZoom, { passive: false });

    function syncViewport() {
        frame = 0;
        if (!mobile.matches) {
            root.style.removeProperty('--frest-overlay-height');
            root.style.removeProperty('--frest-overlay-top');
            return;
        }

        // Do not resize overlays around browser accessibility/menu zoom.
        if (viewport && Math.abs(viewport.scale - 1) > 0.01) return;
        const height = viewport?.height ?? window.innerHeight;
        const top = viewport?.offsetTop ?? 0;
        if (height <= 0) return;
        root.style.setProperty('--frest-overlay-height', `${height}px`);
        root.style.setProperty('--frest-overlay-top', `${top}px`);
    }

    function scheduleSync() {
        if (!frame) frame = requestAnimationFrame(syncViewport);
    }

    syncViewport();
    viewport?.addEventListener('resize', scheduleSync, { passive: true });
    viewport?.addEventListener('scroll', scheduleSync, { passive: true });
    window.addEventListener('resize', scheduleSync, { passive: true });
    window.addEventListener('pageshow', scheduleSync);
    mobile.addEventListener('change', scheduleSync);
    // Measure again when opening a drawer after the browser toolbar has moved.
    document.addEventListener('theme-drawer:open', scheduleSync);
    document.addEventListener('toggle', scheduleSync, true);
})();
